<template>
  <Dialog title="请输入领取红包信息">
    <InputBox placeholder="请输入你的支付宝账号" mb="0.4rem" v-model="alipay" />
    <div class="confirm" @click="handleGetRedpacket">确定</div>
    <div class="cancle" @click="handleClose"></div>
  </Dialog>
</template>

<script>
import Dialog from "./Dialog";
import InputBox from "./inputBox";
import { my_address, buy,award } from "../utils/config";
export default {
  name: "red-packet",
  components: {
    Dialog,
    InputBox
  },
  props:{
    buyId: {
      type: Number,
      default: 0
    },
    fromGoods: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tel: "",
    alipay: "",
    open:true
  }),
  created() {
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      method: "get",
      url: my_address,
      params: {
        goodsType: "HB"
      }
    }).then(res => {
      if (res.data.code !== -1) {
        let { data } = res.data;
        if (!data.address) return;
        let msg = data.address.split("/");
        this.alipay = msg[0];
      }
    });
  },
  methods: {
    handleGetRedpacket() {
       if ( this.alipay) {
        if (this.fromGoods && this.open) {
          this.open = false;
          this.$axios({
            withCredentials: true,
            crossDomain: true,
            method: "get",
            url: award,
            params: {
              buyId: this.buyId
            }
          }).then(res => {
            let { data } = res;
            this.open = true;
            this.$emit("prompt", data.msg);
          });
        } else {
          if (this.open) {
            this.open = false;
            this.$axios({
              withCredentials: true,
              crossDomain: true,
              method: "get",
              url: buy,
              params: {
                vid: this.buyId,
                address: `${this.alipay}`
              }
            }).then(res => {
              let { data } = res;
              if (data.code == 0) {
                this.open = true;
                this.$emit("UPdate", data.data);
                this.$emit("prompt", "购买成功");
              } else {
                this.open = true;
                this.$emit("prompt", data.msg);
              }
            });
          }
        }
      } else {
        this.$emit("prompt", "请填写完整信息");
      }
    },
    handleClose() {
      this.$emit("cancle", { type: "getHB" });
    }
  }
};
</script>

<style scoped lang="scss">
.cancle {
  position: absolute;
  bottom: -132px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  background: url("../assets/guanbi.png") no-repeat;
  background-size: 100% 100%;
}
.confirm {
  width: 100%;
  height: 110px;
  background: #ffdf32;
  text-align: center;
  line-height: 110px;
  font-size: 32px;
  color: #000;
  border-radius: 8px;
}
</style>
